import { useState } from 'react';
import SummaryApi from '../common/index';

function LoginModal({ onClose }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(SummaryApi.signIn.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
  
      const data = await res.json();
  
      if (res.ok) {
        // ✅ Save user to localStorage
        localStorage.setItem('admin', JSON.stringify(data.user));
        
        alert('Login successful!');
        console.log('Logged in user:', data.user);
        onClose();
        
        // Optional: refresh to trigger header update
        window.location.reload();
      } else {
        alert(data.message || 'Login failed');
      }
    } catch (err) {
      alert('Something went wrong', err);
    }
  };
  

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="email" name="email" placeholder="Email" onChange={handleChange} required className="w-full p-2 border" />
          <input type="password" name="password" placeholder="Password" onChange={handleChange} required className="w-full p-2 border" />
          <div className="flex justify-between mt-4">
            <button type="submit" className="bg-orange-500 text-white px-4 py-2 rounded">Login</button>
            <button type="button" onClick={onClose} className="text-gray-600">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;
